import React from 'react';
import {Button} from "../global/Button";

export const Rewards = (props) => {
  const data = props.data || {};

  return (
    <section className="pt-lg-16 pb-lg-21 pt-md-11 pb-md-13 pt-9 pb-11">
      <div className="container">
        <div className="mb-4 mb-md-6 d-flex justify-content-center">
          <span className="zg-label bg-purple me-2" >{data.number}</span>
          <span className="zg-label bg-purple" >{data.subtitle}</span>
        </div>
        <h2 className="h3 mb-8 mb-md-9 mb-lg-11 text-center">
          {data.title}
        </h2>

        {data.items && data.items.length > 0 && (
          <div className="row">
            <div className="col-12 col-xl-10 offset-xl-1">
              <div className="zg-table-wrap mb-5 d-flex d-md-block">
                <div className="px-3 px-md-0 py-3 py-md-0 px-md-6 d-grid zg-card-row zg-card-row--th mb-md-5 me-3 me-md-0">
                  <span className="text-uppercase letter-spacing-4-plus fw-semibold">{data.column1}</span>
                  <span className="text-uppercase letter-spacing-4-plus fw-semibold">{data.column2}</span>
                  <span className="text-uppercase letter-spacing-4-plus fw-semibold">{data.column3}</span>
                </div>
                {
                  data.items.map((item, index) => (
                    <div className="rounded-4 border py-3 py-md-4 px-3 px-md-6 d-grid mb-2 zg-card-row me-2 me-md-0" key={index}>
                      <p className="zg-text-lg mb-0">{item.title}</p>
                      <div>
                        <span className={`rounded-4 px-2 py-1 text-black bg-${item.color}`}>{item.label}</span>
                      </div>
                      <div className="zg-text-md" dangerouslySetInnerHTML={{__html: item.text}}></div>
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        )}
        {data.link && data.link.url && (
          <div className="text-center">
            <Button
              title={data.link.title}
              url={data.link.url}
              classes="btn-lg"
              external={data.link.target === '_blank'}
            />
          </div>
        )}


      </div>
    </section>
  )
}
